var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBackgroundMini = function SvgBackgroundMini(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8C15.2667 8 14.6667 8.6 14.6667 9.33333V12H5.33335V9.33333C5.33335 8.6 4.73335 8 4.00002 8C3.26669 8 2.66669 8.6 2.66669 9.33333V12.6667C2.66669 13.7667 3.56669 14.6667 4.66669 14.6667V15.3333C4.66669 15.7 4.96669 16 5.33335 16C5.70002 16 6.00002 15.7 6.00002 15.3333V14.6667H14V15.3333C14 15.7 14.3 16 14.6667 16C15.0334 16 15.3334 15.7 15.3334 15.3333V14.6667C16.4334 14.6667 17.3334 13.7667 17.3334 12.6667V9.33333C17.3334 8.6 16.7334 8 16 8Z",
    fill: "#00A5B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66669 9.33333V10.6667H13.3334V9.33333C13.3334 8.09333 14.1867 7.06 15.3334 6.76V6C15.3334 4.9 14.4334 4 13.3334 4H6.66669C5.56669 4 4.66669 4.9 4.66669 6V6.76C5.81335 7.06 6.66669 8.09333 6.66669 9.33333Z",
    fill: "#00A5B9"
  })));
};
export default SvgBackgroundMini;